import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { Template } from '../model/central/template.model';
import { STORE_FEATURE_KEY_AR2USER } from './ar2-user.reducer';

const loadingIndicatorSelector = (appState: any) => appState[STORE_FEATURE_KEY_AR2USER].loadingIndicator;
const templatesSelector = (appState: any) => appState[STORE_FEATURE_KEY_AR2USER].templates;
const notificationOffsetsSelector = (appState: any) => appState[STORE_FEATURE_KEY_AR2USER].notificationOffsets;

@Injectable()
export class Ar2UserSelectors {
    constructor(private store: Store<any>) {
    }

    selectTemplates(): Observable<Array<Template>> {
        return this.store
            .pipe(select(templatesSelector));
    }

    selectLoadingIndicatorStatus(): Observable<boolean> {
        return this.store.pipe(select(loadingIndicatorSelector));
    }

    selectNotificationOffsets(): Observable<Array<any>> {
        return this.store.pipe(select(notificationOffsetsSelector));
    }
}
